import { ChakraProvider } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { env, environment } from '@/config/env';
import IframeResizer from '@/providers/IframeResizer';
import { setupStore } from '@/store';
import theme from '@/theme';

import './index.css';
import Fonts from '@/assets/fonts';

import App from './App';
import { ErrorBoundary } from './providers/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: env.GLITCH_TIP_DSN,
  environment,
});

const store = setupStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <Provider store={store}>
    <IframeResizer />

    <ChakraProvider theme={theme}>
      <ErrorBoundary>
        <Fonts />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </ChakraProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
